export const openDocumentation = () => {
  window.location.replace('/developer/docs/introduction');
};
